import { Link } from "../../../navigation";
import Island from "../../common/components/Island";
import Badge from "../../../modules/common/components/Badge";
import Button from "./Button";

const TabList = ({
  tabs,
  appearance,
}: {
  appearance:
    | "switch"
    | "nav"
    | "subnav"
    | "tablist"
    | "verticalnav"
    | "simple";
  tabs: {
    href?: {
      pathname: string;
      query?: any;
    };
    icon?: string;
    onClick?: any;
    isActive?: boolean;
    badgeCount?: number;
    title: string | React.ReactNode;
    shallow?: boolean;
    scroll?: boolean;
  }[];
}) => {
  return (
    <Island className="publicare-tablist" data-appearance={appearance}>
      {tabs.map((tab) => (
        <Island.Item
          key={tab.title as string}
          href={tab.href}
          onClick={tab.onClick}
          LinkComponent={tab.href ? Link : Button}
          active={tab.isActive}
          className="publicare-tablist-item text-nowrap"
          shallow={tab?.shallow ? true : undefined}
          scroll={tab?.scroll ?? undefined}
        >
          {tab?.icon || null}
          {tab.title}
          {tab.badgeCount ? <Badge>{tab.badgeCount}</Badge> : null}
        </Island.Item>
      ))}
    </Island>
  );
};

export default TabList;
